import { motion } from "framer-motion";

// Scroll reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Numbered chapter heading
export const Chapter = ({ number, overline, title, dark = false, className = "" }) => (
  <div className={`mb-16 ${className}`}>
    <Reveal>
      <div className="flex items-center gap-4">
        <span className={`font-display text-lg ${dark ? "text-verra-light" : "text-verra-green"}`}>{number}</span>
        <span className={`overline ${dark ? "text-verra-light" : ""}`}>{overline}</span>
        <span className={`h-px flex-1 ${dark ? "bg-white/15" : "bg-verra-blue/10"}`} />
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className={`mt-6 font-display text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight max-w-3xl ${dark ? "text-white" : "text-verra-blue"}`}>
        {title}
      </h2>
    </Reveal>
  </div>
);
